import { render, staticRenderFns } from "./TextAndImageRight2.vue?vue&type=template&id=6cdf40c2&"
import script from "./TextAndImageRight2.vue?vue&type=script&lang=js&"
export * from "./TextAndImageRight2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports